import styled from '../../../styles/styledComponents/themeComponents';

export const FormListTabStyle = styled.div`
  .add-button {
    margin-bottom: 10px;
    line-height: 35px;
  }

  .ant-tabs-content {
    padding: 15px;
  }
`;
